<template>
  <v-card class="bordered-card" :id="id">
    <video
        style="height: 235px; object-fit: cover; border-radius: 15px"
        width="100%"
        :ref="reff"
        muted
        playsinline
        autoplay
    />
    <div class="under-video-layer-self">
      <div class="current-user-chip">
        <v-btn type="button" class="white--text" fab x-small text @click="$emit('toggleFullScreen', id)">
          <v-icon>mdi-fullscreen</v-icon>
        </v-btn>
        {{ currentUser.name }}
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: "MeetingSelfCardMobile",
  props: [
    'id',
    'reff',
    'colors',
    'currentUser',
  ]
}
</script>

<style scoped>
.bordered-card {
  border: 1px solid black;
  border-radius: 15px !important;
  padding: 0 0 40px;
  height: 275px;
}

.current-user-chip {
  width: 100%;
  justify-content: space-between;
  padding: 0 10px;
  color: white;
  background-color: #f44336;
  border-radius: 15px;
  font-size: 10px;
  text-align: center;
  align-items: center;
  display: flex;
}

.under-video-layer-self {
  height: 35px;
  margin-top: 3px;
  bottom: 0;
  position: absolute;
  padding: 0 3px;
  width: 100%;
  right: 0;
  left: 0;
  text-align: right !important;
}

video {
  transform: rotateY(180deg);
  -webkit-transform:rotateY(180deg); /* Safari and Chrome */
  -moz-transform:rotateY(180deg); /* Firefox */
}
</style>